import {
  CardPaymentActions,
  CartActions,
  ContactInformationActions,
  ReviewActions,
  RewardsPaymentActions,
  WalletActions,
  getObjectKeysAsObject,
} from "@capone/checkout";

import {
  setPaymentFulfillParams,
  setPrepareDetailsFulfillParams,
  setPlatform,
  setWalletCredits,
  checkForPriceChange,
  setInitialBookTime,
} from "./common";
import {
  ActivityTravelerActions,
  ActivityAdditionalDetailsActions,
} from "../../../../checkout";
import addActivityProduct from "./activity";

export const Actions: any = {
  ...CartActions,
  ...ReviewActions,
  ...CardPaymentActions,
  ...WalletActions,
  ...RewardsPaymentActions,
  ...ContactInformationActions,
  ...ActivityTravelerActions,
  ...ActivityAdditionalDetailsActions,

  // activity book actions,
  addActivityProduct,
  checkForPriceChange,

  // common actions
  setPaymentFulfillParams,
  setPrepareDetailsFulfillParams,
  setPlatform,
  setWalletCredits,
  setInitialBookTime,
};

export const ActionTypes = getObjectKeysAsObject(Actions);
